import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { fileUploadS3TestValue } from "../../utils/constants";

export class CashPayLogoUrlField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: fileUploadS3TestValue,
      propertyName: "cashPayLogoUrl",
      uiFieldType: "FileUpload",
      applicable: true,
      required: false,
      shown: true,
      ...opts,
    });
  }

  get uploadFilename(): string {
    const displayName = this._model.storeDetails.storeName.value;
    return `${displayName?.toLowerCase()}_cashpay_logo`;
  }

  // Restrict uploads to png/jpg images
  get uploadFileExtensions(): string {
    return "image/png, image/jpeg";
  }
}
